import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CoreMembersListPage_AddCoreMember($email: String!) {
    addCoreMember(email: $email) {
      id
      email
    }
  }
`)

export const useAddCoreMemberMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (email) =>
      graphQLRequest({
        document,
        variables: { email },
      }),
    ...options,
  })
}
